module.exports = {
  /* eslint-disable */
  githubSrc:
    "https://raw.githubusercontent.com/ohbm/cobidas_schema/master/schemas/eyetracking/protocols/eyetracking_schema.jsonld",
  banner: "This protocol is under construction.",
  startButton: "Start",
  assetsPublicPath: "/cobidas-eyetracker/",
  backendServer: "null",
};
